import { SxProps, Theme } from '@mui/material';

export const productImageZoomContainerSX: SxProps<Theme> = {
	'&.swiper-zoom-container': {
		display: 'block',
		textAlign: 'left',
	},
};

export const productImageZoomTargetSX: SxProps<Theme> = {
	width: '100%',
	height: '100%',
};
